module.exports = __webpack_public_path__ + "static/img/icon_006_b_r.20da6850.png";